import { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

/** Native modal supplies focus containment, Escape handling and focus restoration. */
export default function WorkspaceDialog({ open = true, onClose, title, children, className = '' }) {
  const ref = useRef(null);
  const titleId = useId();
  const { t } = useTranslation('workspace');
  useEffect(() => {
    const dialog = ref.current;
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    const previousFocus = document.activeElement;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [open]);
  return createPortal(
    <dialog ref={ref} className={`ws-dialog ${className}`} aria-labelledby={titleId}
      onCancel={(event) => { event.preventDefault(); onClose(); }}
      onClick={(event) => { if (event.target === event.currentTarget) {
        const rect = event.currentTarget.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) onClose();
      } }}>
      <div className="ws-dialog-heading"><h2 id={titleId}>{title}</h2><button type="button" className="ws-icon-button" onClick={onClose} aria-label={t('close')}><FiX /></button></div>
      {children}
    </dialog>, document.body,
  );
}
